import BaseModelAPI from '../BaseModelAPI';

export default class PickingSupplyForSubcontractList extends BaseModelAPI {

	static entity = 'newobject1947list'
	static entityName = 'pickingsupplyforsubcontract';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
